export const environment = {
  COMPANY_NAME: 'evollo',
  customer: 'cancaonova',
  production: true,
  APP_NAME: 'QUALITY',
  apiUrl: 'https://cancaonova-quality.api.evollo.cloud',
  accountUrl: 'https://cancaonova-account.api.evollo.cloud',
  integrationUrl: 'https://cancaonova-integration.api.evollo.cloud',
  genAiUrl: 'https://genai-integrator-api.evollo.cloud:8485',
  websocketUrl: 'https://websocket-service.evollo.cloud:4949',
  evolloApiUrl: 'https://api.evollo.cloud',
  features: {
    enabledAverageGrade: true,
    enabledChat: false,
    enableChatOperationsFilter: true,
    enableQualityDashboard: false,
    enableInteractionSentiment: false,
    enableSupport: false,
    enableFaq: false,
    homepage: '/interactions',
    cycleAsContactDate: false, // false = data de monitoria || true = data de contato
    enableInteractionMonitorCycle: false,
    aiEnabled: true,
    aiInsightsEnabled: true,
    aiInteractionEnabled: true,
    trainingUrl: null,
    genAiOrganizationFilter: false,
    accessLogEnabled: true,
    initialInteractionDateFilter: true,
    n8nEnabled: true,
    enableChecklistFilter: true,
    monitorInteractionDefaultAnswer: 'NOT_APPLICABLE',
    showInteractionCode: false,
    defaultMonitorItemOpened: false,
    enableMultipleChecklist: true,
    enableMonitorFilter: true,
    enableDurationColumn: true,
    enableDarkMode: false,
  },
  apps: {
    id: 'https://cancaonova.id.evollo.com.br',
    admin: 'https://cancaonova.admin.evollo.com.br',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDuZYbwOh_vxbnmv8NKXiljM4EfNvzWerw',
    authDomain: 'quality-ui.firebaseapp.com',
    projectId: 'quality-ui',
    storageBucket: 'quality-ui.firebasestorage.app',
    messagingSenderId: '1015646958751',
    appId: '1:1015646958751:web:cad29cdde2882247101eaa',
    measurementId: 'G-B5135PSD8K',
  },
  customLabels: {
    justification: 'Tabulação',
    justifications: 'Tabulações',
  },
};
